<template>
  
  <fetch-body-content />
  
</template>

<script lang="ts" setup>

import FetchBodyContent from '@/components/FetchBodyContent.vue';
defineProps();
defineEmits();
defineExpose({ FetchBodyContent });

</script>


<style lang="scss">

</style>